var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{ref:"tplContent",staticClass:"zn-template-content"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../../assets/images/baoxiao.jpg")}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zn-template-head"},[_c('span',{staticClass:"zn-template-title"},[_vm._v("团队报销申请表填写要求")])])
}]

export { render, staticRenderFns }